import { APIService } from "@/service/api.js";
import urlConstant from "@/constants/uri.constants.js";
import Cookies from "js-cookie";

const state = {
    loginResponse: {},
    loginOTPResponse: {},
    registerResponse: {},
};

const mutations = {
    sendOtpEmployee(state, payload) {
        switch (payload.type) {
            case "LOGING_EMPLOYEE":
                state.loginResponse = {
                    isLoging: true,
                    errorLoging: false,
                    responseData: {}
                };
                break;
            case "LOGEDIN_EMPLOYEE":
                state.loginResponse = {
                    isLoging: false,
                    errorLoging: false,
                    responseData: payload.data
                };
                break;
        }
    },
    verifyLoginOTP(state, payload) {
        switch (payload.type) {
            case "VERIFYING_LOGIN_OTP":
                state.loginOTPResponse = {
                    isverifying: true,
                    errorVerify: false,
                    responseData: {}
                };
                break;
            case "VERIFIED_LOGIN_OTP":
                state.loginOTPResponse = {
                    isverifying: false,
                    errorVerify: false,
                    responseData: payload.data
                };
                break;
        }
    },
    registerEmployee(state, payload) {
        switch (payload.type) {
            case "REGISTERING_EMPLOYEE":
                state.registerResponse = {
                    isRegistering: true,
                    errorRegistering: false,
                    responseData: {}
                };
                break;
            case "REGISTERED_EMPLOYEE":
                state.registerResponse = {
                    isRegistering: false,
                    errorRegistering: false,
                    responseData: payload.data
                };
                break;
        }
    },

};

const actions = {
    actionEmployeeSendOtp({ commit }, _loginObj) {
        commit("sendOtpEmployee", { type: "LOGING_EMPLOYEE" });
        APIService.post(urlConstant.baseUrl + urlConstant.employeeSendOtp, _loginObj)
            .then(res => {
                if (res.data) {
                    // console.log("actionEmployeeSendOtp");
                    commit("sendOtpEmployee", { type: "LOGEDIN_EMPLOYEE", data: res.data });
                }
            })
            .catch(err => {
                console.log("createTopic", err);
            });
    },

    actionVerifyLoginOTP({ commit }, _otpDetails) {
        commit("verifyLoginOTP", { type: "VERIFYING_LOGIN_OTP" });
        APIService.post(urlConstant.baseUrl + urlConstant.employeeOtpLoginVerify, _otpDetails)
            .then(res => {
                if (res.data) {
                    // console.log(res.data);
                    commit("verifyLoginOTP", { type: "VERIFIED_LOGIN_OTP", data: res.data });
                }
            })
            .catch(err => {
                console.log("createTopic", err);
            });
    },

    actionRegisterEmployee({ commit }, _employeeDetails) {
        commit("registerEmployee", { type: "REGISTERING_EMPLOYEE" });
        const jwtToken= Cookies.get("authToken");
        const userId= Cookies.get("userId");
        APIService.post(urlConstant.baseUrl + urlConstant.employeeRegister, _employeeDetails,{ headers: {"jwt" : jwtToken, userid:userId}})
            .then(res => {
                if (res.data) {
                    // console.log(res.data);
                    commit("registerEmployee", { type: "REGISTERED_EMPLOYEE", data: res.data });
                }
            })
            .catch(err => {
                console.log("createTopic", err);
            });
    },

   
    
};

export default {
    namespaced: true,
    state,
    actions,
    mutations
};
